import { ArrowUpRight } from "lucide-react";

const cinzel = "font-['Cinzel',serif]";

/** Only verified metadata is rendered — missing fields are simply skipped. */
export function getMetaTags(result) {
  const tags = [];
  if (typeof result.grafts === "number") tags.push(`${result.grafts.toLocaleString("en-IN")} grafts`);
  if (result.technique) tags.push(result.technique);
  if (result.area) tags.push(result.area);
  if (result.timeline) tags.push(result.timeline);
  return tags;
}

export default function ResultCard({ result, onOpen }) {
  const tags = getMetaTags(result);

  return (
    <article
      data-card
      className="group flex flex-col overflow-hidden rounded-2xl border border-[#c9a84c]/25 bg-white shadow-[0_2px_4px_rgba(90,60,10,0.05),0_8px_24px_rgba(90,60,10,0.08)] transition-all duration-300 hover:-translate-y-1.5 hover:border-[#c9a84c]/60 hover:shadow-[0_4px_8px_rgba(90,60,10,0.07),0_18px_44px_rgba(90,60,10,0.14)] motion-reduce:transition-none motion-reduce:hover:translate-y-0"
    >
      {/* before | after */}
      <div
        onClick={() => onOpen(result.id)}
        className="relative grid cursor-pointer grid-cols-2 gap-px bg-[#c9a84c]/40"
      >
        <div className="relative aspect-[3/4] overflow-hidden bg-[#1a0f02]">
          <img
            src={result.before}
            alt={`Before hair transplant — ${result.label}`}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04] motion-reduce:transition-none"
          />
          <span className={`${cinzel} absolute bottom-2 left-2 rounded-full bg-black/70 px-2.5 py-1 text-[8px] tracking-[0.16em] text-white/85`}>
            BEFORE
          </span>
        </div>
        <div className="relative aspect-[3/4] overflow-hidden bg-[#1a0f02]">
          <img
            src={result.after}
            alt={`After hair transplant — ${result.label}`}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04] motion-reduce:transition-none"
          />
          <span className={`${cinzel} absolute bottom-2 right-2 rounded-full bg-[#c9a84c]/90 px-2.5 py-1 text-[8px] font-bold tracking-[0.16em] text-[#1a0f02]`}>
            AFTER
          </span>
        </div>
      </div>

      {/* details */}
      <div className="flex flex-1 flex-col gap-3 p-4 sm:p-5">
        <h3 className={`${cinzel} text-[15px] font-bold tracking-[0.04em] text-[#1a0f02]`}>{result.label}</h3>

        {tags.length > 0 && (
          <ul className="flex flex-wrap gap-1.5">
            {tags.map((t) => (
              <li
                key={t}
                className="rounded-full border border-[#c9a84c]/30 bg-[#c9a84c]/10 px-2.5 py-1 font-['Raleway',sans-serif] text-[11px] font-medium text-[#a07828]"
              >
                {t}
              </li>
            ))}
          </ul>
        )}

        <button
          type="button"
          onClick={() => onOpen(result.id)}
          aria-label={`View transformation — ${result.label}`}
          className={`${cinzel} mt-auto inline-flex items-center gap-1.5 self-start border-b border-[#c9a84c]/50 pb-0.5 text-[10.5px] font-bold uppercase tracking-[0.14em] text-[#a07828] transition-colors hover:border-[#a07828] hover:text-[#1a0f02] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#c9a84c]`}
        >
          View Transformation
          <ArrowUpRight size={14} aria-hidden="true" />
        </button>
      </div>
    </article>
  );
}